import Env from '../base/env.js'
import Channels from '../base/channels'
import axios from 'axios'
import Serializer from 'form-serialize'
import Cookies from 'js-cookie'
import 'babel-polyfill'

class RegisterMail
{
    constructor(_view)
    {
        this.$form = _view;
        if(this.$form == null) return false;
        this.$fields = this.$form.querySelectorAll('.field')
        this.$status = this.$form.querySelector('.jsStatus')
        this.events()
        this.loadCsrf();
    }

    cookieRegistration()
    {
        if(typeof Cookies.get('moodletter_subscription') == 'undefined') {
            Cookies.set('moodletter_subscription', '1', { expires: 365 });
        }
    }

    events()
    {
        this.$form.addEventListener('submit',(event)=> {
            if(!this.$form.classList.contains('for--success') && !this.$form.classList.contains('for--error') && !this.$form.classList.contains('for--loading'))
            {
                this.send()
            }
            event.preventDefault()
        })
    }

    fail()
    {
        this.$form.classList.add('for--error');
        setTimeout(()=> {
            this.$form.classList.remove('for--error');
        }, 4000);
    }

    loadCsrf()
    {
        axios.get(config.pathRoot+'form-tok').then((response)=> {
            let $input = document.createElement('input')
            $input.setAttribute('name','_token')
            $input.setAttribute('type','hidden')
            $input.value = response.data
            this.$form.appendChild($input)
        });
    }

    ok()
    {
        this.$form.classList.add('for--success');
        this.cookieRegistration()
        if(Env.framework.UI.popinAlert.ENABLED) {
            setTimeout(() => {
                Env.framework.UI.popinAlert.close()
            }, 1600);
        }
    }

    send()
    {
        const $datas = Serializer(this.$form , { hash: true})
        if(typeof $datas.email != 'undefined') {
            this.$form.classList.remove('for--success')
            this.$form.classList.remove('for--error')
            this.$form.classList.remove('for--loading')
            this.$form.classList.add('for--loading')

            axios({
                method: "post",
                url: this.$form.getAttribute('action'),
                data: $datas,
                responseType : 'json'
            }).then((response)=>{
                this.$form.classList.remove('for--loading')
                this.$status.innerHTML = ''
                const paragraph = document.createElement('p')
                paragraph.innerHTML = response.data.messages
                this.$status.appendChild(paragraph)
                if(response.data.success == 1)
                {
                    this.ok();
                }
                else
                {
                    if(typeof response.data.callback != 'undefined' && response.data.callback == 'member_already') {
                        this.cookieRegistration()
                    }
                    this.fail()
                }
            })
        }


    }
}

export default RegisterMail;